module.exports = __webpack_public_path__ + "static/media/file-import.0c21e008.svg";